/** @format */

import {ORDER_STATUS_COMPLETE, PRODUCT_TYPE_GRAPHIC_DESIGN} from 'frontier-constants';
import {OrderShipping} from './tab_views/order_shipping/order_shipping';
import {OrderArtwork} from './tab_views/order_artwork/order_artwork';
import {withRouter, If, IfElse} from 'frontier-utilities';
import {OrderDetails} from './tab_views/order_details';
import {OrderBilling} from './tab_views/order_billing';
import {OrderProofs} from './tab_views/order_proofs';
import {Tabs, Tab} from '@sttark/design-system';
import {Link} from 'react-router-dom';
import React, {useState} from 'react';
import {useOrder} from './use_order';

// styles
import './container.scss';

export default withRouter(props => {
    const {id} = props.match.params;
    const {order, cart, designs_orders, proofs, handleUpdateProof} = useOrder(id);
    const [activeTab, setActiveTab] = useState('order_details');

    const onTabChangeTab = tab => {
        setActiveTab(tab);
    };

    const isGraphicDesign = order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN;
    const isPrintedProofOnly = order.is_printed_proof_only;

    return (
        <div className="orders-view-order-05jr">
            <Link
                to={
                    order.status_id === ORDER_STATUS_COMPLETE
                        ? '/account/orders/reorders'
                        : '/account/orders/index'
                }>
                <div className="orders-view-order-05jr__id d-inline-flex align-items-center justify-content-start">
                    <i className="fa fa-caret-left" />
                    <h3 className="m-0">#{order.id}</h3>
                </div>
            </Link>
            <Tabs activeTab={activeTab} onChange={onTabChangeTab} className={'tabs mb-0'}>
                <Tab title="Order Details" name="order_details">
                    <section className="orders-view-order-05jr__card-section">
                        <OrderDetails order={order} />
                    </section>
                </Tab>
                <Tab title="Artwork" name="artwork">
                    <section className="orders-view-order-05jr__card-section">
                        <OrderArtwork order={order} designsOrders={designs_orders} />
                    </section>
                </Tab>
                <Tab title="Proofs" name="proofs">
                    <IfElse condition={proofs.length > 0}>
                        <section className="orders-view-order-05jr__card-section">
                            <OrderProofs proofs={proofs} onUpdateProof={handleUpdateProof} />
                        </section>
                        <div className="alert alert-info info">
                            There are no proofs in this order
                        </div>
                    </IfElse>
                </Tab>

                <Tab
                    title={isGraphicDesign || isPrintedProofOnly ? '' : 'Shipments'}
                    name={isGraphicDesign || isPrintedProofOnly ? '' : 'shipping'}>
                    <section className="orders-view-order-05jr__card-section">
                        <OrderShipping cart={cart} />
                    </section>
                </Tab>
            </Tabs>
        </div>
    );
});
